
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexuVcDMe_45G9ataFdG9ehvkxfZCIWcSc1ryVRQLI1XmtEUMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/index.vue?macro=true";
import { default as contactQ0nz3DUOWBgzeBD4zAlBt0xfhh_l8xSaGh6M7FBm5KoMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/contact.vue?macro=true";
import { default as privacyH0SxWabDYbD0xzg_450IrOKVC1Ohon1Ohj16ORZNuTkHYMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/privacy.vue?macro=true";
import { default as disclaimerCbT4V1LexQVUlBxCGZI61Qzi87T9ZBsDf7IQoYFGdewMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/disclaimer.vue?macro=true";
import { default as indexhJGxgeNVR64zzOjm5Abo9xD4S84G10CeQ6fJA5VxxCAMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/dashboard/index.vue?macro=true";
import { default as indexgn1HdfGkttWFL7_453VkwON3UEpGRteYXJyb390CJRsa4Meta } from "/builds/void-zero/clients/mijn-epd/app/pages/tools/monitoring/index.vue?macro=true";
import { default as index8BuiMJBn8NnokgRysyv2RQB_JtvSE90uKr7omcxcFEkMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/tools/streefwaarden/index.vue?macro=true";
import { default as indexKdb1sf3JB6OZ3PFon58ODwZEaPVeLc2Dl_vKz63WJVoMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/dashboard/category/[id]/index.vue?macro=true";
import { default as _91fileId_93VbQMJtyDhEDXIPRqrBgTmLdD6NRsAHVzj4mhaO9xsIkMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/dashboard/category/[id]/[fileId].vue?macro=true";
import { default as streefwaarden_46flowchartEj_45hsWrLr9x_YovP_lSSXnJVZKlkjQCMo4rYvjqlR1UMeta } from "/builds/void-zero/clients/mijn-epd/app/pages/tools/streefwaarden/streefwaarden.flowchart.ts?macro=true";
import { default as component_45stubfXNBV7wxdsYUANBRsfO2LtF0PKokcv3Byg1M_gOi128Meta } from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.26.0_jiti@2.4_c5ce664d060fbe5735a78455e2c10bdf/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubfXNBV7wxdsYUANBRsfO2LtF0PKokcv3Byg1M_gOi128 } from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.26.0_jiti@2.4_c5ce664d060fbe5735a78455e2c10bdf/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___nl",
    path: "/",
    meta: { ...(indexuVcDMe_45G9ataFdG9ehvkxfZCIWcSc1ryVRQLI1XmtEUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/index.vue")
  },
  {
    name: "contact___nl",
    path: "/contact/",
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/contact.vue")
  },
  {
    name: "privacy___nl",
    path: "/privacy/",
    meta: privacyH0SxWabDYbD0xzg_450IrOKVC1Ohon1Ohj16ORZNuTkHYMeta || {},
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/privacy.vue")
  },
  {
    name: "disclaimer___nl",
    path: "/disclaimer/",
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/disclaimer.vue")
  },
  {
    name: "dashboard___nl",
    path: "/dashboard/",
    meta: { ...(indexhJGxgeNVR64zzOjm5Abo9xD4S84G10CeQ6fJA5VxxCAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/dashboard/index.vue")
  },
  {
    name: "tools-monitoring___nl",
    path: "/tools/monitoring/",
    meta: indexgn1HdfGkttWFL7_453VkwON3UEpGRteYXJyb390CJRsa4Meta || {},
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/tools/monitoring/index.vue")
  },
  {
    name: "tools-streefwaarden___nl",
    path: "/tools/streefwaarden/",
    meta: { ...(index8BuiMJBn8NnokgRysyv2RQB_JtvSE90uKr7omcxcFEkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/tools/streefwaarden/index.vue")
  },
  {
    name: "dashboard-category-id___nl",
    path: "/dashboard/category/:id()/",
    meta: { ...(indexKdb1sf3JB6OZ3PFon58ODwZEaPVeLc2Dl_vKz63WJVoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/dashboard/category/[id]/index.vue")
  },
  {
    name: "dashboard-category-id-fileId___nl",
    path: "/dashboard/category/:id()/:fileId()/",
    meta: { ...(_91fileId_93VbQMJtyDhEDXIPRqrBgTmLdD6NRsAHVzj4mhaO9xsIkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/dashboard/category/[id]/[fileId].vue")
  },
  {
    name: "tools-streefwaarden-streefwaarden.flowchart___nl",
    path: "/tools/streefwaarden/streefwaarden.flowchart/",
    component: () => import("/builds/void-zero/clients/mijn-epd/app/pages/tools/streefwaarden/streefwaarden.flowchart.ts")
  },
  {
    name: component_45stubfXNBV7wxdsYUANBRsfO2LtF0PKokcv3Byg1M_gOi128Meta?.name,
    path: "/sitemap.xml/",
    component: component_45stubfXNBV7wxdsYUANBRsfO2LtF0PKokcv3Byg1M_gOi128
  }
]